import { ChangeDetectionStrategy, Component, DOCUMENT, Inject, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'sb-not-found-page',
    templateUrl: './not-found-page.component.html',
    styleUrls: ['./not-found-page.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
})
export class NotFoundPageComponent implements OnInit {
    constructor(
        private titleService: Title,
        private translateService: TranslateService,
        @Inject(DOCUMENT) private document: Document,
    ) {}

    ngOnInit() {
        this.setTitle(this.translateService.instant('Page not found'));

        // need to reset min-width: 1000px
        this.document.body.style.minWidth = 'unset';
    }

    private setTitle(newTitle: string) {
        this.titleService.setTitle(newTitle);
    }
}
